import { createContext } from 'react';

const TabVisibleContext = createContext(true);
export default TabVisibleContext;
